"use strict";
exports.__esModule = true;
var ACTIVITY_EVENTS = [
    'mousedown', 'mousemove', 'keydown',
    'scroll', 'touchstart',
];
var ActivityDetector = (function () {
    function ActivityDetector(inactiveThresholdInSecond) {
        var _this = this;
        this.destroy = function () {
            ACTIVITY_EVENTS.forEach(function (eventName) {
                document.removeEventListener(eventName, _this.onActivity, true);
            });
        };
        this.onActivity = function () {
            _this.lastActivityTimestamp = Date.now();
        };
        this.registerListeners = function () {
            ACTIVITY_EVENTS.forEach(function (eventName) {
                document.addEventListener(eventName, _this.onActivity, true);
            });
        };
        this.getSecondsSinceLastActivity = function () { return Math.round((Date.now() - _this.lastActivityTimestamp) / 1000); };
        this.getIsActive = function () {
            return _this.getSecondsSinceLastActivity() < _this.inactiveThresholdInSecond;
        };
        this.lastActivityTimestamp = Date.now();
        this.inactiveThresholdInSecond = inactiveThresholdInSecond;
        this.registerListeners();
    }
    return ActivityDetector;
}());
exports["default"] = ActivityDetector;
//# sourceMappingURL=ActivityDetector.js.map